import { LoaderCircle, RefreshCw, Wifi, WifiOff } from "lucide-react";

type ConnectionState = "offline" | "connecting" | "online" | "reconnecting";

const labels: Record<ConnectionState, string> = {
  offline: "当前离线",
  connecting: "正在连接",
  online: "实时连接正常",
  reconnecting: "正在重新连接"
};

export function ConnectionStatus({ state }: { state: ConnectionState }) {
  const Icon = state === "online" ? Wifi : state === "offline" ? WifiOff : state === "connecting" ? LoaderCircle : RefreshCw;
  return <span className={`connection-status is-${state}`} role="status"><Icon className={state === "connecting" || state === "reconnecting" ? "spin" : undefined} aria-hidden="true" />{labels[state]}</span>;
}
